export function init(subForm) {
  const emailInput = document.getElementById('sub-email');
  const errorContainer = document.getElementById('subscribe-error');
  const errorText = document.getElementById('subscribe-error-text');

  if (subForm && emailInput) {
    function showError(msg) {
      if (errorContainer && errorText) {
        errorText.textContent = msg;
        errorContainer.classList.remove('hidden');
      }
    }

    function hideError() {
      if (errorContainer) {
        errorContainer.classList.add('hidden');
      }
    }

    async function getChallenge(email) {
      try {
        const response = await fetch(`/api/captcha-challenge?email=${encodeURIComponent(email)}`);
        if (!response.ok) {
          throw new Error('Challenge fetch failed');
        }
        const json = await response.json();
        const ticket = json.ticket;
        const difficulty = ticket.split('.')?.[1];
        return {ticket, difficulty }; 
      } catch (e) {
        console.error("Failed to get challenge", e);
        return null;
      }
    }

    async function solvePoW(challenge) {
      if (!challenge) {
        return null;
      }
            
      const { ticket, difficulty } = challenge;
      const prefix = '0'.repeat(difficulty);
      let nonce = 0;
    
      const encoder = new TextEncoder();
      const ticketData = encoder.encode(ticket);
    
      while (true) {
        for (let i = 0; i < 1500; i++) {
          const nonceStr = String(nonce);
          const data = new Uint8Array(ticketData.length + nonceStr.length);
          data.set(ticketData);
          data.set(encoder.encode(nonceStr), ticketData.length);
        
          const hashBuffer = await crypto.subtle.digest('SHA-256', data);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        
          if (hashHex.startsWith(prefix)) {
            return { nonce, ticket };
          }
          nonce++;
        }
        await new Promise(r => setTimeout(r, 0));
      }
    }

    subForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      hideError();
    
      const email = emailInput.value;
      const submitBtn = subForm.querySelector('button[type="submit"]');
      const originalContent = submitBtn.innerHTML;

      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="animate-pulse">Securing connection...</span>';

      const challenge = await getChallenge(email);
      if (!challenge) {
        showError("Server communication error. Please try again.");
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalContent;
        return;
      }

      submitBtn.innerHTML = '<span class="animate-pulse">Validating request...</span>';
      const solution = await solvePoW(challenge);

      if (!solution) {
        showError("Security check could not be completed.");
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalContent;
        return;
      }

      submitBtn.innerHTML = 'Sending...';
      const topics = ['LAUNCH'];
      if (subForm.querySelector('[name="newsletter"]').checked) {
        topics.push('NEWSLETTER');
      }

      try {
        const response = await fetch('/api/subscribe', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            topics: topics,
            ticket: solution.ticket,
            nonce: String(solution.nonce),
            b_website: subForm.querySelector('[name="b_website"]').value
          })
        });

        if (response.ok) {
          document.getElementById('subscribe-form-container').classList.add('hidden');
          document.getElementById('subscribe-success').classList.remove('hidden');
        } else {
          const err = await response.text();
          showError("Error: " + err);
        }
      } catch (err) {
        console.error(err);
        showError("Network error. Please check your connection.");
      } finally {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalContent;
      }
    });
  }
}

